var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"animated fadeIn"},[_c('Incoming',{attrs:{"productList":_vm.productList},on:{"reload":_vm.loadProducts}}),_c('Outcoming',{attrs:{"productList":_vm.productList},on:{"reload":_vm.loadProducts}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }